import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  ADD_STATE_INIT_ACTION,
  ADD_STATE_SUCCESS_ACTION,
  ADD_STATE_FAIL_ACTION,
  FETCH_STATELIST_INIT_ACTION,
  FETCH_STATELIST_SUCCESS_ACTION,
  FETCH_STATELIST_FAIL_ACTION,
  DELETE_STATE_INIT_ACTION,
  DELETE_STATE_SUCCESS_ACTION,
  DELETE_STATE_FAIL_ACTION,
  UPDATE_STATE_INIT_ACTION,
  UPDATE_STATE_SUCCESS_ACTION,
  UPDATE_STATE_FAIL_ACTION,
  FETCH_STATE_SEARCH_INIT_ACTION,
  FETCH_STATE_SEARCH_SUCCESS_ACTION,
  FETCH_STATE_SEARCH_FAIL_ACTION,
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* addState(value) {
 
  try {

    let latitude = value.value.latitude;
    let longitude = value.value.longitude;
    const StateValue = {
      name: value.value.name,
      code: value.value.code,
      type: value.value.type,
      capital: value.value.capital,
      districts: [],
      coordinates: [latitude,longitude]
    };

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/state`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(StateValue),
    });


    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
        yield toast.error(`failed to add state: ${errJSON.message}`, {
          autoClose: 3000,
        });
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_STATELIST_INIT_ACTION,
      });
      
      yield toast.success("State added successfully", {
        autoClose: 3000,
      });
     
      yield put({
        type: ADD_STATE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_STATE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchStateList(value) {
 
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/state?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
    
      yield put({
        type: FETCH_STATELIST_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_STATELIST_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* deleteState(items) {
 

  const StateValue = {
    access_token: items.items.id,
  };
 
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/state/` + items.items.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!res.ok) {    
      let errJSON = {};
      try {
        errJSON = yield res.json();
        if(errJSON){
          yield toast.error("Delete not allowed", {
            autoClose: 3000,
          });
        }
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      yield put({
        type: FETCH_STATELIST_INIT_ACTION,
      });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();
     
     
      yield put({
        type: DELETE_STATE_SUCCESS_ACTION,
      });
    }
  } catch (err) {
   
    if (err.ok === false) {
     
      yield put({
        type: DELETE_STATE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editState(value) {
  
  const coordinates = []
  coordinates.push(value.value.latitude, value.value.longitude)
 
  let id=value.value.id
  
  const token = localStorage.getItem("token");

  const StateValue = {
    name: value.value.name,
    code: value.value.code,
    coordinates: coordinates,
    capital: value.value.capital,
    type: value.value.type,
    districts: [],
  };

  try {
    const res = yield fetch(`${appConfig.ip}/state/`+ id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(StateValue)

    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
    
      yield put({
        type: FETCH_STATELIST_INIT_ACTION,
       
      });
      yield toast.success('State updated successfully', {
        autoClose: 3000
    })
    yield put({
      type: UPDATE_STATE_SUCCESS_ACTION,
      payload: resJSON,
    });
     
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: UPDATE_STATE_FAIL_ACTION, error: err });
    } else {
    }
  }

}

function* stateSearch(value) {
  
  let searchVal = value.value.searchState

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/state?limit=10&page=` + value.value.Spage + '&search=' + searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_STATE_SEARCH_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_STATE_SEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}


export function* StateActionWatcher() {
  yield takeEvery(ADD_STATE_INIT_ACTION, addState);
  yield takeEvery(FETCH_STATELIST_INIT_ACTION, fetchStateList);
  yield takeEvery(DELETE_STATE_INIT_ACTION, deleteState);
  yield takeEvery(UPDATE_STATE_INIT_ACTION, editState);
  yield takeEvery(FETCH_STATE_SEARCH_INIT_ACTION, stateSearch);
}

